import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

/** @const {string} Default landing route after sign-in and for `/`. */
export const APP_HOME_PATH = "/dashboard";

const RETURN_TO_KEY = "orderlink:returnTo";

/**
 * True when value is a same-origin relative path (starts with `/` but not `//`).
 *
 * @param {unknown} value
 * @return {boolean}
 */
const isSafeReturnTo = value =>
  typeof value === "string" && value.startsWith("/") && !value.startsWith("//");

/**
 * Sends an authenticated user to a saved return path or the operations dashboard.
 *
 * @return {null}
 */
const HomeRedirect = () => {
  const navigate = useNavigate();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const returnTo = sessionStorage.getItem(RETURN_TO_KEY);
    if (isSafeReturnTo(returnTo)) {
      sessionStorage.removeItem(RETURN_TO_KEY);
      navigate(returnTo, { replace: true });
      return;
    }

    navigate(APP_HOME_PATH, { replace: true });
  }, [navigate]);

  return null;
};

export { HomeRedirect };
